var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('field');
import { breakpoints, theme } from '@shapeable/theme';
export var FieldDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    font-family: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    font-size: ", "em;\n  "], ["\n    padding-bottom: ", ";\n    font-family: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    font-size: ", "em;\n  "])), theme.UNIT(4), theme.FONT('sans'), theme.COLOR('text-subtle'), 14 / 16)
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.label.attrs(cls.attr('label'))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var Field = function Field(props) {
  var className = props.className,
      label = props.label,
      children = props.children,
      id = props.id,
      name = props.name,
      isRequired = props.isRequired;
  var hasLabel = !!label;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasLabel && React.createElement(My.Label, {
    htmlFor: id || name
  }, label), children);
};
Field.defaultProps = FieldDefaultProps;
Field.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;